export default __webpack_public_path__ + "static/media/accessibility.31c61150.jpg";